module.exports = __webpack_public_path__ + "static/media/index-shop-6.1bce3106.webp";